import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';

import { API_URL, apiFetch } from '@/config/api';

export interface VoteTagOption {
  value: string;
  label: string;
}

export function useVoteTags() {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: ['vote-tags'],
    queryFn: async (): Promise<VoteTagOption[]> => {
      const token = await getAccessTokenSilently();
      const response = await apiFetch(`${API_URL}/admin/vote-tags`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) {
        return [];
      }
      return await response.json();
    },
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
